import ProductService from '@/services/ProductService.js'

export const state = {
  unitProducts: [],
  unitProduct: {}
}

export const mutations = {
  ADD_UNIT_PRODUCT(state, unitProduct) {
    state.unitProducts.push(unitProduct)
  },
  DELETE_UNIT_PRODUCT(state, unitProduct) {
    state.unitProducts = state.unitProducts.filter(t => t.id != unitProduct.unitId)
  },
  EDIT_UNIT_PRODUCT(state, unitProduct) {
    state.unitProduct = unitProduct
  },
  SET_UNIT_PRODUCTS(state, unitProducts) {
    state.unitProducts = unitProducts
  },
  SET_UNIT_PRODUCT(state, unitProduct) {
    state.unitProduct = unitProduct
  }
}

export const namespaced = true //all mutations, actions, getters will be namespaced under "Product"//

export const actions = {
  createUnitProduct({ commit, dispatch }, unitProduct) {
    return ProductService.postUnitProduct(unitProduct)
      .then((response) => {
        let notification
        if (response.data.error && response.data.error === true) {
          notification = {
            type: 'error',
            message: response.data.message
          }
          throw response.data
        } else {
          commit('ADD_UNIT_PRODUCT', unitProduct)
          notification = {
            type: 'success',
            message: 'Your new product has been added to the unit!'
          }
        }
        dispatch('notification/add', notification, { root: true })  
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message:
            'There was a problem adding product to the unit: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  fetchUnitProducts({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      ProductService.getUnitProducts(id)
      .then(response => {
        commit('SET_UNIT_PRODUCTS', response.data)
        return resolve(response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message:
            'There was a problem fetching unit products: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        return reject(error)
      })
    })
  },
  fetchUnitProduct({ commit, getters }, { unitId, productId }) {
    var unitProduct = getters.getUnitProductById(unitId, productId)

    if (unitProduct) {
      commit('SET_UNIT_PRODUCT', unitProduct)
      return unitProduct
    } else {
      return ProductService.getUnitProduct(unitId, productId) // <-- Send the prop ids to our ProductService//
        .then(response => {
          commit('SET_UNIT_PRODUCT', response.data[0])
          return response.data[0]
        })
    }
  },
  async removeUnitProduct({ commit }, unitProduct) {
    await ProductService.deleteUnitProduct(unitProduct.unitId, unitProduct.productId)
    commit('DELETE_UNIT_PRODUCT', unitProduct)
  },
  async editUnitProduct({ commit }, unitProduct) {
    await ProductService.updateUnitProduct(unitProduct)
    commit('EDIT_UNIT_PRODUCT', unitProduct)
  },
  async editUnitProductStock({ commit, dispatch }, unitProduct) {
    return new Promise((resolve, reject) => {
      ProductService.updateUnitProductStock(unitProduct)
      .then(response => {
        if (response.data.error && response.data.error === true) throw response.data.message
        commit('EDIT_UNIT_PRODUCT', unitProduct)
        return resolve(response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message:
            'There was a problem fetching low stock unit products: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        return reject(error)
      })
    })
  },
  getLowstockUnitProducts({ dispatch }) {
    return new Promise((resolve, reject) => {
      ProductService.getLowstockUnitProducts()
      .then(response => {
        return resolve(response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message:
            'There was a problem fetching low stock unit products: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        return reject(error)
      })
    })
  },
  searchUnitProducts({ commit, dispatch }, searchJson) {
    ProductService.searchUnitProducts(searchJson.id, searchJson.search)
      .then(response => {
        commit('SET_UNIT_PRODUCTS', response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem searching unit products: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })
  },
  convertTextToImage({ dispatch }, textJson) {
    return ProductService.convertTextToImage(textJson)
      .then(response => {
        return response.data
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem converting text to image: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })
  },
  copyUnitProductImage({ dispatch }, copyJson) {
    return ProductService.copyUnitProductImage(copyJson)
      .then(response => {
        return response.data
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem copying image: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })
  },
  fetchUnitProductsToRestock({ dispatch }, id) {
    return new Promise((resolve, reject) => {
      ProductService.getUnitProductsToRestock(id)
      .then(response => {
        return resolve(response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message:
            'There was a problem fetching unit products to restock: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        return reject(error)
      })
    })
  },
}

export const getters = {
  getUnitProductById: state => (unitId, productId) => {
    return state.unitProducts.find(
      unitProduct => 
      (unitProduct.unit_id === unitId,unitProduct.product_id === productId))
  }
}
